import React from 'react';
import { float2D } from '../../../utils/Validation';

export default function PricePerBox({ PieceAndPrice }) {

    return (
        <div className="col-sm-12">
            <h4 className="section-title bold">Minimum Pieces per Box</h4>
            <table id="data-table-5" className="table-price-align w-100 thead-primary dataTable no-footer" role="grid" aria-describedby="data-table-5_info" >
                <thead>
                    <tr role="row" className='tr-price-align'>
                        <th>Pieces per Box</th>
                        <th>Minimum Box Count</th>
                        <th>Price per Box</th>
                    </tr>
                </thead>
                {PieceAndPrice.map((cake, index) =>
                    <tbody key={index}>
                        <tr className='odd price-align2-row'>
                            <th className="sorting_1 id-column" scope="row">{cake.Piece} Pieces</th>
                            <td>{cake.MinCount}</td>
                            <td className='no-price-align-details'>Rs. {float2D(cake.PricePerBox)}</td>
                        </tr>
                    </tbody>
                )}
            </table>
        </div>
    )
};